module.exports = __webpack_public_path__ + "img/logo.b40f864b.png";